module.exports = __webpack_public_path__ + "static/media/ios-log-in.eed1898b.svg";